import React from 'react';
import DistanceItem from './DistanceItem';

const DistanceList = ({ distances, onDistancesUpdated, eventId }) => {
    return (
        <table className='table table-bordered'>
            <thead className='thead-light'>
            <tr>
                <th>Название</th>
                <th>Дистанция</th>
                <th>Набор высоты</th>
                <th>ITRA баллы</th>
                <th>Доступно</th>
                <th>Действия</th>
            </tr>
            </thead>
            <tbody>
            {distances.map(distance => (
                <DistanceItem
                    key={distance.id}
                    distance={distance}
                    eventId={eventId}
                    onDistancesUpdated={onDistancesUpdated}
                />
            ))}
            </tbody>
        </table>
    );
};

export default DistanceList;